var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var Router = ReactRouter.Router;
var Link = ReactRouter.Link;
var Reflux = require('reflux');
var ScreenWid = require('./stores/screen-wid-store');
var Shopify = require('./shopify');
var ScrollToTop = require('./scroll-to-top');

var QtyAdj = React.createClass({

  getInitialState: function() {
    return { qty: this.props.qty }
  },

  inc: function() {
    this.props.qtyChange(1);
    this.setState({ qty: this.state.qty + 1 })
  },

  dec: function() {
    if (this.state.qty > 0) {
      this.props.qtyChange(-1);
      this.setState({ qty: this.state.qty - 1 })
    }
  },

  render: function() {
    return <div className="qty-inc-dec">
        <div onClick={this.dec} className="btn-adj">-</div>
        <div className="qty-num">{this.state.qty}</div>
        <div onClick={this.inc} className="btn-adj">+</div>  
      </div>
  } 
});

var CartRow = React.createClass({

  qty: 0,

  getInitialState: function() {
    this.qty = this.props.product.quantity;
    return { lineTotal: this.props.product.line_price / 100 }
  },

  handleQtyChange: function(delta) {
    this.qty += delta;
    this.props.qtyChange(this.props.product.variant_id, this.qty, this.props.product.price * delta / 100);
    this.setState({ lineTotal: Math.round(this.state.lineTotal * 100 + this.props.product.price * delta) / 100 })
  },

  render: function() {
    return <div className="cart-row">
                <div className="row">
                    <div className="prod-img col-sm-2">
                      <a href={"/products/" + this.props.product.handle}>
                          <img src={this.props.product.image ? this.props.product.image : ImageUrl.dummyShoe}>
                          </img>
                      </a>
                    </div>
                    <div className="prod-title col-sm-2">{this.props.product.product_title}</div>
                    <div className="prod-size col-sm-2">
                        {this.props.product.variant_options[1]} - {this.props.product.variant_options[2]}
                    </div>
                    <div className="prod-price col-sm-2">${(this.props.product.price / 100).toFixed(2)}</div>
                    <div className="prod-qty col-sm-2">
                        <QtyAdj qty={this.props.product.quantity}
                                qtyChange={this.handleQtyChange} />
                    </div>
                    <div className="prod-subtotal col-sm-2">${(this.state.lineTotal).toFixed(2)}</div>
                </div>
        </div>
  } 
});

var CartRowM = React.createClass({

  qty: 0,

  getInitialState: function() {
    this.qty = this.props.product.quantity;
    return { lineTotal: this.props.product.line_price / 100 }
  },

  handleQtyChange: function(delta) {
    this.qty += delta;
    this.props.qtyChange(this.props.product.variant_id, this.qty, this.props.product.price * delta / 100);
    this.setState({ lineTotal: Math.round(this.state.lineTotal * 100 + this.props.product.price * delta) / 100 })
  },

  render: function() {
    var prodColor = this.props.product.variant_options[0].split(' ')[0];

    return <div className="cart-row">
                <div className="row">
                    <div className="prod-img col-xs-4">
                        <a href={"/products/" + this.props.product.handle}>
                            <img src={this.props.product.image ? this.props.product.image : ImageUrl.dummyShoe}>
                            </img>
                        </a>
                        <div className="prod-title-m">{this.props.product.product_title}</div>
                        <div className="prod-size-m">{prodColor + " | SIZE: " + this.props.product.variant_options[1]}</div>
                        <div className="prod-price-m">${(this.props.product.price / 100).toFixed(2)}</div>
                    </div>
                    <div className="prod-qty col-xs-4">
                        <QtyAdj qty={this.props.product.quantity}
                                qtyChange={this.handleQtyChange} />
                    </div>
                    <div className="prod-subtotal col-xs-4">${(this.state.lineTotal).toFixed(2)}</div>
                </div>
        </div>
  } 
});

module.exports = React.createClass({
  
  mixins: [ ScrollToTop, Reflux.listenTo(ScreenWid, "screenWidthCrossSM") ],

  cartContent: {},
  adjustQueue: [],
  callPending: false,
  tableHeader: <div id="cart-head">
                   <div className="row">
                       <div className="prod-img col-sm-2 hidden-xs"></div>
                       <div className="prod-title col-xs-4 col-sm-2">PRODUCT</div>
                       <div className="prod-size col-sm-2 hidden-xs">SIZE</div>
                       <div className="prod-price col-sm-2 hidden-xs">PRICE</div>
                       <div className="prod-qty col-xs-4 col-sm-2">QTY</div>
                       <div className="prod-subtotal col-xs-4 col-sm-2">SUBTOTAL</div>
                   </div>
               </div>,
  forMobile: [],
  forDesktop: [],
  requested: [],
  unmounted: false,

  getInitialState: function() {

    Shopify.getCartContent(this.cartContentGot);
    return { rows: [],
             cartTotal: 0.0 }
  },

  componentDidMount: function() {

    document.title = "My Bag - Ingledew's Shoes";

    this.scrollToTop('cart-page');
    var script_tag = document.createElement("script");
    script_tag.type = "text/javascript";
    script_tag.src = StorePickupJs;
    jQuery(ReactDOM.findDOMNode(this.refs.form)).append(script_tag);

    var decoded =  jQuery('<div/>').html(CMS.bagPage.words).text();
    var explanation = jQuery('<small>').html(decoded);
    jQuery(ReactDOM.findDOMNode(this.refs.subTotal)).append(explanation);

    this.forMobile = [this.refs.rowsMobile],
    this.forDesktop = [this.refs.rowsDesktop],
    this.screenWidthCrossSM("change", ScreenWid.width);

    setTimeout(this.checkStorePickupDone, 1000);
  },
  
  componentWillUnmount: function() {
    this.unmounted = true;
  },

  screenWidthCrossSM: function(event, wid) {
    if ("SM" == wid) {
      this.forMobile.map(function(el) {
        jQuery(el).removeClass('hide');
      });
      this.forDesktop.map(function(el) {
        jQuery(el).addClass('hide');
      });
    } else {
      this.forMobile.map(function(el) {
        jQuery(el).addClass('hide');
      });
      this.forDesktop.map(function(el) {
        jQuery(el).removeClass('hide');
      });
    }
  },

  checkStorePickupDone: function() {
    if (jQuery('#shippingMethod').length) {
      var btsp = document.createElement('script');
      btsp.src = "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js";
      document.getElementsByTagName('head')[0].appendChild(btsp);

      btsp = document.createElement('script');
      btsp.src = "//cdnjs.cloudflare.com/ajax/libs/flexslider/2.5.0/jquery.flexslider.min.js";
      document.getElementsByTagName('head')[0].appendChild(btsp);

      btsp = document.createElement('script');
      btsp.src = coolShareUrl;
      document.getElementsByTagName('head')[0].appendChild(btsp);

    } else {
      setTimeout(this.checkStorePickupDone, 500);
    }
  },

  handleQtyChange: function(id, newQty, priceDelta) {
    this.requested.push({ id: id, qty: newQty });
    if (this.callPending) {
      this.adjustQueue.push({ id: id, qty: newQty });
    } else {
      this.adjustLineQty(id, newQty);
    }
  },

  createRows: function() {
    return this.cartContent.items.map(function(item) {
      return <CartRow product={item} qtyChange={this.handleQtyChange}
                      key={item.variant_id}/>
    }.bind(this));
  },

  createRowsM: function() {
    return this.cartContent.items.map(function(item) {
      return <CartRowM product={item} qtyChange={this.handleQtyChange}
                       key={item.variant_id}/>
    }.bind(this));
  },

  cartContentGot: function(cart) {
    if (this.unmounted) return;

    this.cartContent = cart;
    if (cart.items.length) {
      this.setState({ tableHeader: this.tableHeader,
                      rows: this.createRows(),
                      rowsMobile: this.createRowsM(),
                      cartTotal: cart.total_price / 100 });
      jQuery(ReactDOM.findDOMNode(this.refs.tableFooter)).css('display', 'block');
      jQuery('#checkout-btn').css('display', 'block');
    } else {
      this.setState({ tableHeader: [],
                      rows: <p className="bag-empty-msg">Bag is currently empty.</p>,
                      rowsMobile: <p className="bag-empty-msg">Bag is currently empty.</p>,
                      cartTotal: 0.00 });
      jQuery(ReactDOM.findDOMNode(this.refs.tableFooter)).css('display', 'none');
      jQuery('#checkout-btn').css('display', 'none');
    }
  },

  adjustLineQty: function(id, qty) {
    this.callPending = true;
    Shopify.adjustCartLineQty(id, qty, this.cartUpdated);
  },

  cartUpdated: function(result, cart) {
    if (this.adjustQueue.length) {
      var next = adjustQueue.shift();
      this.adjustLineQty(next.id, next.qty);
    } else {
      this.checkIfStockAvailable(cart);
      this.setState({ rows: [] });
      this.cartContentGot(cart);
      this.props.updateBag(cart);
      this.callPending = false;
    }
  },

  checkIfStockAvailable(cart) {
    var exceeded = [];

    this.requested.map(function(row) {
      var inCart = _.find(cart.items,
                          function(item) { return item.variant_id == row.id });

      if (row.qty && row.qty > inCart.quantity) {
        exceeded.push({id: row.id, title: inCart.title, reqQty: row.qty, inStock: inCart.quantity });
      }
    }.bind(this));
    if (exceeded.length) {
        this.props.showThankYou("Not enough: " + exceeded[0].title, "Out of stock", "OK");
    }
    this.requested = [];
  },

  render: function() {
    return <main id="content" className="container" role="main">
                <h1>My shopping bag</h1>
                <form action="/cart" method="post" ref="form">
                    {this.state.tableHeader}
                    <div ref="rowsDesktop">
                        {this.state.rows}
                    </div>
                    <div ref="rowsMobile">
                        {this.state.rowsMobile}
                    </div>
                    <div className="row  sub-div" ref="tableFooter">
                        <div className="col-xs-8 col-sm-6 col-md-4 col-md-offset-4 sub-text" ref="subTotal">
                            <p><b>SUB TOTAL</b></p>
                        </div>
                        <div className="col-xs-4 col-sm-2 col-sm-push-4 col-md-2 col-md-push-2">
                            <b>${(this.state.cartTotal).toFixed(2)}</b>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8 col-md-offset-4">
                            <div id="storePickupApp"></div>
                        </div>
                    </div>
                    <input type="hidden" value={SitePermamentDomain} id="shop_identifier" />
                    
                    <div className="row submit-wrap" id="checkout-btn">
                    <div className="col-md-8 col-md-offset-4">
                        <input type="submit" name="checkout" value="CONTINUE TO CHECK OUT"
                               className="btn btn-primary form-checkout-btn"></input>
                    </div>
               </div>
                </form>
      </main>
  } 
});